import React from 'react';
import { PageLoaderWrapper } from './pageLoader.styled';
import CircularProgress from '@mui/material/CircularProgress';

const PageLoader = () => {
	return (
		<PageLoaderWrapper className=" flex-center">
			<CircularProgress size="4rem" sx={{ color: '#5AC0FC' }} />
		</PageLoaderWrapper>
	);
};

export default React.memo(PageLoader);
